import { render, staticRenderFns } from "./paySlipItem.vue?vue&type=template&id=5ab86e00&scoped=true&"
import script from "./paySlipItem.vue?vue&type=script&lang=js&"
export * from "./paySlipItem.vue?vue&type=script&lang=js&"
import style0 from "./paySlipItem.vue?vue&type=style&index=0&id=5ab86e00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab86e00",
  null
  
)

export default component.exports